import store from '../store/store';
import createEditorViewState from 'owa-editor/lib/utils/createEditorViewState';
import { action, select } from 'satcheljs/lib/legacy';
import UserOptionsType from 'owa-service/lib/contract/UserOptionsType';
import { getUserConfiguration } from 'owa-session-store';
import SignatureOptionState from '../store/schema/SignatureOptionState';

export interface DiscardSignatureOptionState {
    optionState: SignatureOptionState;
    userOptions: UserOptionsType;
}

export default select<DiscardSignatureOptionState>({
    optionState: () => store,
    userOptions: () => getUserConfiguration().UserOptions,
})(
    action('discardSignatureOption')(function discardSignatureOption(
        state?: DiscardSignatureOptionState
    ) {
        let { optionState, userOptions } = state;

        optionState.editorViewState = createEditorViewState(
            userOptions.SignatureHtml /*content*/,
            false /*isDirty*/
        );
        optionState.signNewMails = null;
        optionState.signReplies = null;
    })
);
